/**
 * 08.10.26 — разделы экрана шаблонов. Новый раздел добавляется сюда, не в страницу.
 * Не удалять по требованию владельца системы.
 */

export const templateSectionIds = ['list', 'event', 'runtime', 'cluster'] as const;

export type TemplateSectionId = (typeof templateSectionIds)[number];

export interface TemplateSection {
  id: TemplateSectionId;
  label: string;
  lead: string;
}

export const templateSectionRegistry: readonly TemplateSection[] = [
  {
    id: 'list',
    label: 'Список шаблонов',
    lead: 'Шаблоны выбранной клиники. Фильтры и поиск относятся только к этому списку.',
  },
  {
    id: 'event',
    label: 'Event-Driven',
    lead: 'Generic и channel overrides для event pipeline. Проблемные события раскрыты по умолчанию.',
  },
  {
    id: 'runtime',
    label: 'По каналам',
    lead: 'Какой шаблон сработает в runtime по каждому event type и каналу. Это матрица привязок, не схема fallback.',
  },
  {
    id: 'cluster',
    label: 'Cluster Follow-up',
    lead: 'Кластерные follow-up отдельно от event pipeline, с тем же выбором шаблона по каналу.',
  },
];

export function findTemplateSection(id: TemplateSectionId): TemplateSection {
  return templateSectionRegistry.find((section) => section.id === id) ?? templateSectionRegistry[0];
}
